@app.directive 'shopifyButtonForm', (ShopifyService)->
  restrict: 'E'
  scope: {}
  controllerAs: 'shopifyButtonForm'
  controller: ->
    @productOptions = ShopifyService.products
    this

  bindToController: {
    content: '='
  }
  templateUrl: "/assets/templates/components/customButton/shopifyButton/shopifyButtonForm.html"
